export default {
  methods: [
    {
      label: '刷新页面',
      value: 'refresh',
    },
  ],
};
